:host {
    .ti-video-player-show-player {
        visibility: visible;
        height: 100%;
    }

    .ti-video-player-hide-player {
        visibility: hidden;
    }

    .ti-video-player-loader-container {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
    }
}
